var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"inline-svg",style:({
    color: _vm.color,
    width: _vm.width
  }),domProps:{"innerHTML":_vm._s(_vm.icon)},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }